import axios from 'axios';

export default {
  uploadMediaToS3(form, s3Params) {
    let formData = new FormData();

    for (let key in s3Params.formInputs) {
      formData.append(key, s3Params.formInputs[key]);
    }
    formData.append('file', form.uploadFile);
    return axios.post(s3Params.formAttributes.action, formData);
  },

  registerFiles(networkSlugs, files, s3Prefix, collection = { name: 'Enter your collection name' }) {
    return axios.post('networks/register-files-for-media', {
      files,
      s3Prefix,
      networkSlugs,
      collection,
    });
  },
};
